import { AuthContextProps } from "../components/auth-context";
import { getData, putData } from "./core";

export default class PaymentApi {
  static uri = "payment";
  static authorizedUri = "a/accounts/payment";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: string, discountCode: string) {
    return getData({
      uri: PaymentApi.uri,
      id,
      params: `?discountCode=${discountCode}`,
      context: this.context,
    });
  }

  getAll(page: number, rows: number) {
    return getData({
      uri: PaymentApi.authorizedUri,
      params: `?page=${page}&rows=${rows}`,
      context: this.context,
    });
  }
  
  put(
    id: string,
    discountCode: string,
    depositPay: boolean,
    creditPay: boolean, 
    selectedBankId:number
  ) {
    return putData({
      uri: PaymentApi.authorizedUri,
      data: { id, discountCode, depositPay, creditPay,selectedBankId },
      context: this.context,
    });
  }
}
